import { parsedJsonString } from "utils/UtilityFuncs";

// Split Shipments address helpers (user, 2026-11-04).

// A customer address row -> the shape shipments store (same mapping as
// WorkOrders/ManageWo/ShippingAddress.jsx).
export const toShippingAddress = (a) => ({
  addressCompany: a?.companyName || a?.addressCompany || "",
  addressContact: a?.addressContact || "",
  addressLine1: a?.addressLine1 || "",
  addressLine2: a?.addressLine2 || "",
  city: a?.city || "",
  state: a?.state || "",
  zip: a?.zip || "",
  country: a?.country || "",
  addressType: a?.addressType || "",
});

// Addresses are sometimes stringified more than once.
export const parseAddress = (raw) => {
  const a = parsedJsonString(raw);
  return a && typeof a === "object" ? a : null;
};

export const addressLines = (a) => {
  if (!a) return [];
  return [
    a.addressCompany,
    a.addressContact,
    a.addressLine1,
    a.addressLine2,
    [a.city, a.state, a.zip].filter(Boolean).join(", "),
    a.country,
  ].filter(Boolean);
};

export const addressLabel = (a) => addressLines(a).join(", ") || "No address";

export const SPLIT_STATUSES = [
  { value: "pending", label: "Pending", badge: "secondary" },
  { value: "packed", label: "Packed", badge: "warning" },
  { value: "shipped", label: "Shipped", badge: "success" },
];

export const statusBadge = (status) =>
  SPLIT_STATUSES.find((s) => s.value === status) || SPLIT_STATUSES[0];
